import { useEffect } from "react";

import { useAppDispatch, useAppSelector } from "app/hooks";

import { caseViewerActions } from "./store/slice";

import { userSelectors } from "features/user/store/selectors";

export function CaseViewerUserSettingsLoader() {
    const dispatch = useAppDispatch();

    const userSettings = useAppSelector(userSelectors.selectUserSettings);

    useEffect(() => {
        if (userSettings) {
            dispatch(
                caseViewerActions.initDebugSettingsUsingUserSettings({
                    userSettings,
                }),
            );
        }
    }, [userSettings]);

    return undefined;
}
